import { render, staticRenderFns } from "./RiskScenarioCreateForm.vue?vue&type=template&id=45f2efd2&"
import script from "./RiskScenarioCreateForm.vue?vue&type=script&lang=js&"
export * from "./RiskScenarioCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports